import { Flex, Tab, TabList, Tabs } from '@chakra-ui/react';
import { startTransition } from 'react';

import { FeatureFlag, TourClasses } from '@revelio/core';

import { useUnleashFlag } from '../../../../shared/unleash-flags/use-unleash-flag';
import { usePageState } from '../PageState/PageStateProvider';
import { resolveActiveTab } from '../PageState/resolveActiveTab';
import { NewLayoutTabManager } from './NewLayoutTabManager';
import { useGetTabs, useSyncResolvedActiveTab, useUpdateTab } from './useTabs';

export const TabManager = () => {
  const isNewDashboardLayout = useUnleashFlag(FeatureFlag.DashboardNewLayout);

  useSyncResolvedActiveTab();

  if (isNewDashboardLayout) {
    return <NewLayoutTabManager />;
  }

  return <LegacyTabManager />;
};

const LegacyTabManager = () => {
  const tabs = useGetTabs();
  const { pageState } = usePageState();
  const updateTab = useUpdateTab();

  const handleTabChange = (tabIndex: number) => {
    const tabId = tabs[tabIndex]?.id;
    if (!tabId) return;

    startTransition(() => {
      updateTab(tabId);
    });
  };

  if (tabs.length === 1) return null;

  return (
    <Flex alignItems="center" className={TourClasses.TOUR_VIEW_CLASS}>
      <Tabs
        onChange={handleTabChange}
        index={tabs.findIndex(
          (tab) => tab.id === resolveActiveTab(tabs, pageState.activeTabId)?.id
        )}
        sx={{
          '[role=tab]': {
            _selected: {
              color: 'text.primary',
              borderBottom: '3px solid',
              borderColor: 'green.500',
            },
            _hover: {
              color: 'text.primary',
            },
            _active: {
              bg: 'none',
            },
          },
        }}
      >
        <TabList borderBottom="0px solid">
          {tabs.map((tab) => (
            <Tab
              key={tab.id}
              margin="0 10px"
              padding="0 0 4px"
              color="#8F9CB2"
              fontWeight="600"
              fontSize="13px"
            >
              {tab.label}
            </Tab>
          ))}
        </TabList>
      </Tabs>
    </Flex>
  );
};
